import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Home from "../Pages/Home/home";
import CourseView from "../Pages/Courses/courseView";
import CoursesByCategoryView from "../Pages/Courses/Category/CoursesByCategoryView";
import PublicProfile from "../Pages/Profile/publicProfile";
import { LANGUAGE_KEY } from "../Constants/mainKeys";
import ShoppingCart from "../Pages/ShoppingCart/shoppingCart";
import WishList from "../Pages/WishList/wishList";
import CreateConsultation from "../Pages/CreateConsultation/createConsultation";
import ConsultantFeed from "../Pages/ConsultantFeed/consultantFeed";
import ForStudentView from "../Pages/ConsultationViewPages/ForStudent/forStudentView";
import ContractPageForStudent from "../Pages/ConsultationContarctPages/ForStudent/contractPageForStudent";
import JoinOneTimeWebinar from "../Pages/Webinars/joinOneTimeWebinar";
import CreateOneTimeWebinar from "../Pages/Webinars/createOneTimeWebinar";
import Overview from "../Pages/Overview/overview";
import AllConsultations from "../Pages/ConsultationViewPages/AllConsultations/allConsultations";
import Finances from "../Pages/Overview/finances";
import Notifications from "../Pages/Notifications/notifications";
import Profile from "../Pages/Profile/profile";
import Messages from "../Pages/Messages/messages";
import Tickets from "../Pages/Tickets/tickets";
import Checkout from "../Pages/Checkout/checkout";
import Terms from "../UserPages/Policy/terms";
import DataPolicy from "../UserPages/Policy/dataPolicy";
import CookiesPocicy from "../UserPages/Policy/cookiesPolicy";
import Info from "../UserPages/Info/info";
import FooterMenu from "../UserPages/FooterMenu/footerMenu";
import NotFoundPage from "../Pages/404/notFoundPage";
import Chat from "./../Pages/Tickets/Components/chat";
import AllMessages from "../Pages/Messages/allMessages";
import Help from "../Pages/Help/help";
import Faq from "../Pages/Help/faq";
import Topic from "../Pages/Help/topic";
import OrganizationForm from "../UserPages/Organization/organizationForm";
import ContactUs from "../UserPages/ContactUs/contactUs";
import UnderMaintenancePage from "../Pages/UnderMaintenancePage/underMaintenancePage";
import CustomPaymentPackage from "../UserPages/CustomPaymentPackage/customPaymentPackage";
import AuthenticationByRefreshToken from "../Pages/AuthenticationByRefreshToken/AuthenticationByRefreshToken";
import _Help from "../Pages/Help/_help";
import About from "../UserPages/About/about";
import TermsAndCondition from "../UserPages/TermsAndCondition/termsAndCondition";
import PrivacyPolicy from "../UserPages/PrivacyPolicy/privacyPolicy";
import LogOut from "../Pages/LogOut/LogOut";

const BaseRoutes = () => {
	return (
		<Switch>
			{/* Profile */}
			<Route path="/:language/profile" exact component={PublicProfile} />
			<Route
				path="/:language/profile/:userId"
				exact
				component={PublicProfile}
			/>

			{/* Webinars */}
			<Route
				path="/:language/onetimewebinar/:webinarId/:webinarCalendarId/:lecturerUserId"
				exact
				component={JoinOneTimeWebinar}
			/>
			<Route
				path="/:language/video-conference-room/:webinarId/:webinarCalendarId/:lecturerUserId"
				exact
				component={JoinOneTimeWebinar}
			/>
			{/* <Route path="/:language/create-onetime-webinar" exact component={CreateOneTimeWebinar} />
    <Route path="/:language/create-onetime-webinar/:webinarId" exact component={CreateOneTimeWebinar} /> */}
			<Route
				path="/:language/video-conference"
				exact
				component={CreateOneTimeWebinar}
			/>
			<Route
				path="/:language/video-conference/:webinarId"
				exact
				component={CreateOneTimeWebinar}
			/>

			{/* Courses by category */}
			<Route
				path="/:language/category"
				exact
				component={CoursesByCategoryView}
			/>
			<Route
				path="/:language/category/:mainCategoryId"
				exact
				component={CoursesByCategoryView}
			/>
			<Route
				path="/:language/category/:mainCategoryId/:categoryId"
				exact
				component={CoursesByCategoryView}
			/>
			<Route
				path="/:language/category/:mainCategoryId/:categoryId/:subcategoryId"
				exact
				component={CoursesByCategoryView}
			/>

			{/* Course view, Courses table, form */}
			<Route path="/:language/courses/:courseId" exact component={CourseView} />
			<Route
				path="/:language/courses/:courseId/returnurl"
				exact
				component={CourseView}
			/>

			{/* ShopingCart */}
			<Route path="/:language/shopping-cart" exact component={ShoppingCart} />

			{/* Wish List */}
			<Route path="/:language/wish-list" exact component={WishList} />

			{/* Consultation */}
			<Route
				path="/:language/create-consultation"
				exact
				component={CreateConsultation}
			/>
			<Route
				path="/:language/create-consultation/:consultationId"
				exact
				component={CreateConsultation}
			/>
			<Route
				path="/:language/consultant-feed"
				exact
				component={ConsultantFeed}
			/>
			<Route
				path="/:language/student-consultation-dashboard/"
				exact
				component={ForStudentView}
			/>
			<Route
				path="/:language/student-consultation-dashboard/:contractState/:consultationId"
				exact
				component={ForStudentView}
			/>
			<Route
				path="/:language/student-consultation-contracts/:contractId"
				exact
				component={ContractPageForStudent}
			/>
			<Route
				path="/:language/student-consultation-contracts/:contractId/:contractState"
				exact
				component={ContractPageForStudent}
			/>
			<Route
				path="/:language/student-consultation-contracts/:contractId/feedback"
				exact
				component={ContractPageForStudent}
			/>
			<Route
				path="/:language/student-consultation-contracts/:contractId/returnurl"
				exact
				component={ContractPageForStudent}
			/>
			<Route
				path="/:language/all-consultations"
				exact
				component={AllConsultations}
			/>

			{/* Finances Overview */}
			<Route path="/:language/student/overview" exact component={Overview} />
			<Route path="/:language/student/finances" exact component={Finances} />
			<Route
				path="/:language/student/finances/stripesuccess/returnurl"
				exact
				component={Finances}
			/>
			<Route
				path="/:language/student/finances/stripecancel/returnurl"
				exact
				component={Finances}
			/>
			<Route
				path="/:language/student/finances/paypalsuccess/returnurl"
				exact
				component={Finances}
			/>
			<Route
				path="/:language/student/finances/paypalcancel/returnurl"
				exact
				component={Finances}
			/>
			<Route
				path="/:language/student/finances/cryllexsuccess/returnurl"
				exact
				component={Finances}
			/>
			<Route
				path="/:language/student/finances/cryllexcancel/returnurl"
				exact
				component={Finances}
			/>

			{/* Notifications */}
			<Route path="/:language/notifications" exact component={Notifications} />

			{/* Edit profile */}
			<Route path="/:language/edit-profile" exact component={Profile} />

			{/* Messages */}
			<Route path="/:language/messages" exact component={Messages} />
			<Route path="/:language/messages/:senderId" exact component={Messages} />
			<Route path="/:language/all-messages" exact component={AllMessages} />

			{/* Tickets */}
			<Route path="/:language/tickets" exact component={Tickets} />
			<Route path="/:language/ticket/chat/:ticketId" exact component={Chat} />

			{/* Help */}
			{/* <Route path="/:language/help" exact component={Help} />
    <Route path="/:language/help/:pageName" exact component={Help} />
    <Route path="/:language/help/:pageName/FAQ" exact component={Faq} />
    <Route path="/:language/help/:pageName/topic/:topicId" exact component={Topic} /> */}
			<Route path="/:language/help" exact component={_Help} />
			<Route path="/:language/help/topic/:topicId" exact component={_Help} />
			<Route path="/:language/help/faq/:faqId" exact component={_Help} />

			{/* Checkout */}
			<Route path="/:language/checkout" exact component={Checkout} />
			<Route
				path="/:language/checkout/paypalsuccess/returnurl"
				exact
				component={Checkout}
			/>
			<Route
				path="/:language/checkout/paypalcancel/returnurl"
				exact
				component={Checkout}
			/>
			<Route
				path="/:language/checkout/stripesuccess/returnurl"
				exact
				component={Checkout}
			/>
			<Route
				path="/:language/checkout/stripecancel/returnurl"
				exact
				component={Checkout}
			/>
			<Route
				path="/:language/checkout/cryllexsuccess/returnurl"
				exact
				component={Checkout}
			/>
			<Route
				path="/:language/checkout/cryllexcancel/returnurl"
				exact
				component={Checkout}
			/>
			<Route path="/:language/checkout/:courseId" exact component={Checkout} />

			{/* Home Page */}
			<Route path="/:language" exact component={Home} />

			{/* Terms and Policy */}
			<Route path="/:language/terms" exact component={Terms} />
			<Route path="/:language/data-policy" exact component={DataPolicy} />

			{/* Info page */}
			<Route
				path="/:language/mindalay-for-institutions/info"
				exact
				component={Info}
			/>
			<Route path="/:language/learn-in-mindalay/info" exact component={Info} />
			<Route path="/:language/teach-in-mindalay/info" exact component={Info} />
			<Route path="/:language/become-consultant/info" exact component={Info} />

			<Route
				path="/:language/organization-admin/organization-form"
				exact
				component={OrganizationForm}
			/>

			{/* 404 */}
			<Route path="/:language/not-found/404" exact component={NotFoundPage} />

			{/* Contact us */}
			<Route path="/:language/contact-us" exact component={ContactUs} />
			<Route path="/:language/about/:pageId" exact component={About} />
			<Route
				path="/:language/privacy-policy/:pageId"
				exact
				component={PrivacyPolicy}
			/>
			<Route
				path="/:language/cookies-policy/:pageId"
				exact
				component={CookiesPocicy}
			/>
			<Route
				path="/:language/terms-and-condition/:pageId"
				exact
				component={TermsAndCondition}
			/>

			<Route
				path="/:language/custom-payment-package"
				exact
				component={CustomPaymentPackage}
			/>
			{/* About-us info */}
			<Route path="/:language/tariffs/:pageId" exact component={FooterMenu} />
			<Route
				path="/:language/platform-instructions/:pageId"
				exact
				component={FooterMenu}
			/>
			<Route
				path="/:language/company-policy/:pageId"
				exact
				component={FooterMenu}
			/>
			<Route
				path="/:language/personal-data-processing-policy/:pageId"
				exact
				component={FooterMenu}
			/>

			{/* AuthenticationByRefreshToken */}
			<Route
				path="/:language/authentication/:refreshToken"
				exact
				component={AuthenticationByRefreshToken}
			/>

			{/* Server error page */}
			<Route
				path="/:language/under-maintenance"
				exact
				component={UnderMaintenancePage}
			/>
			<Route path="/:language/logout" exact component={LogOut} />
			<Redirect to={`/${localStorage.getItem(LANGUAGE_KEY)}`} />
			<Route component={NotFoundPage} />
		</Switch>
	);
};

export default BaseRoutes;
